import { Container, Row, Col } from "react-bootstrap";
import styles from "./DataCenterPage.module.css";
import { LowerMainBannerHeader, UpperMainBannerHeader } from "./DataCenterSvg";
import { QuestionBlock, QuestionCard } from "./QuestionsModule";
import { useState } from "react";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";

function MainBannerCol({ header, text }) {
  return (
    <div className={styles.mainBannerCol}>
      <h4>{header}</h4>
      <p>{text}</p>
    </div>
  );
}

function MainBanner({ isXs, isSm }) {
  const { lang, changeLang, t } = useLang();

  const cols = [
    {
      header: t("DCMainColHeader1"),
      text: t("DCMainColText1"),
    },
    {
      header: t("DCMainColHeader2"),
      text: t("DCMainColText2"),
    },
    {
      header: t("DCMainColHeader3"),
      text: t("DCMainColText3"),
    },
    {
      header: t("DCMainColHeader4"),
      text: t("DCMainColText4"),
    },
  ];
  return (
    <div className={`${styles.mainBanner}`}>
      <div
        className={`${styles.mainBannerContainer} d-flex justify-content-center`}
        style={
          isXs || isSm
            ? { padding: "36px", paddingBottom: "20px" }
            : { padding: "72px", paddingBottom: "30px" }
        }
      >
        <Container>
          <Row>
            <Col xs={12}>
              <div className={styles.mainBannerHeaderContainer}>
                {/* <UpperMainBannerHeader
                  className={`${styles.mainBannerHeader} position-relative`}
                /> */}
                <LowerMainBannerHeader className={styles.mainBannerHeader} />
              </div>
            </Col>
          </Row>
          <Row
            xs={1}
            md={2}
            xl={4}
            className={` ${isXs || isSm ? "g-4 mt-3" : "g-5 mt-1"}`}
          >
            {cols.map((el, index) => (
              <Col key={index}>
                <MainBannerCol {...el} />
              </Col>
            ))}
          </Row>
          <Row xs={1}>
            <Col>
              <hr style={{ borderColor: "rgba(255, 255, 255, 0.30)" }} />
              <h2 className={`${styles.mainBannerBottomHeader} mt-4`}>
                {t("DCFooter")}
              </h2>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

function ProsCard({ header, text, src }) {
  const { s, toggleTheme } = useTheme();

  return (
    <div className={styles.prosCard} style={s.DCProsCard}>
      <h4 style={{ color: s.DCProsHeader, fontFamily: "Gilroy-semibold" }}>
        {header}
      </h4>
      <p className="mt-1" style={{ color: s.DCProsText }}>
        {text}
      </p>
      <div className="w-100 mt-auto d-flex justify-content-center">
        <img draggable="false" src={src} />
      </div>
    </div>
  );
}

function ProsCards() {
  const { lang, changeLang, t } = useLang();

  const cards = [
    {
      header: t("DCCardHeader1"),
      text: t("DCCardText1"),
      src: "/img/strongDuck.gif",
    },
    {
      header: t("DCCardHeader2"),
      text: t("DCCardText2"),
      src: "/img/wallDuck.gif",
    },
    {
      header: t("DCCardHeader3"),
      text: t("DCCardText3"),
      src: "/img/flyingDuck.gif",
    },
  ];
  return (
    <Row xs={1} lg={3} className="mt-4">
      {cards.map((el) => {
        return (
          <Col className="gy-4">
            <ProsCard {...el} />
          </Col>
        );
      })}
    </Row>
  );
}

function MinorBanner({ isLg, isXl }) {
  const { lang, changeLang, t } = useLang();

  const { s, toggleTheme } = useTheme();
  return (
    <div className={`${styles.minorBanner} mt-4`} style={s.DCProsCard}>
      {isXl && (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="551"
            height="174"
            viewBox="0 0 551 174"
            fill="none"
            className={styles.minorBannerLeft}
          >
            {s.DCMinorLeft}
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="487"
            height="180"
            viewBox="0 0 487 180"
            fill="none"
            className={styles.minorBannerRight}
          >
            {s.DCMinorRight}
          </svg>
        </>
      )}
      <h4 style={{ color: s.DCProsHeader }}>looking glass</h4>
      <p className="mt-1" style={{ color: s.DCProsText }}>
        {t("DCMinorBannerText1")}
        {(isLg || isXl) && <br />}
        {t("DCMinorBannerText2")}
      </p>
      <button className={`mt-1 ${styles.minorBtn}`} style={s.DCProsBtn}>
        <span className={styles.btnText}>lg.qwins.co</span>
      </button>
    </div>
  );
}

function QuestionsModule() {
  const [openedCard, setOpenedCard] = useState(null);
  const { lang, changeLang, t } = useLang();

  const cards = [
    {
      header: t("DCqHeader1"),
      isOpened: true,
      description: t("DCqText1"),
      key: 0,
    },
    {
      header: t("DCqHeader2"),
      isOpened: true,
      description: t("DCqText2"),
      key: 1,
    },
    {
      header: t("DCqHeader3"),
      isOpened: true,
      description: t("DCqText3"),
      key: 2,
    },
  ];
  return (
    <Row className="mt-2  gx-3 gy-3">
      <Col xs={12} md={12} lg={6}>
        <Row xs={1} className="gy-2">
          {cards.map((el) => (
            <Col>
              <QuestionCard
                {...el}
                isOpened={el.key === openedCard}
                setOpened={setOpenedCard}
                index={el.key}
                key={el.key}
              />
            </Col>
          ))}
        </Row>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader1")}
          description={t("qCardDescr1")}
          linkText={t("qCardLink1")}
          link={"https://wiki.qwins.co/"}
        />
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader2")}
          description={t("qCardDescr2")}
          linkText={t("qCardLink2")}
          link={"https://t.me/qwinshelp"}
        />
      </Col>
    </Row>
  );
}

export default function DataCenterPage({ windowSize }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();
  return (
    <>
      <MainBanner isXs={windowSize.isXs} isSm={windowSize.isSm} />
      <ProsCards />
      <MinorBanner isLg={windowSize.isLg} isXl={windowSize.isXl} />

      <div style={{ textAlign: "left" }}>
        <h4 className={`${styles.minorHeader} mt-5 mb-0`} style={s.minorHeader}>
          {t("qMinorHeader")}
        </h4>
      </div>
      <QuestionsModule />
    </>
  );
}
